export default __webpack_public_path__ + "static/media/sam.22787a73.jpg";